import(/* webpackMode: "eager", webpackExports: ["WorkPage"] */ "C:\\apps\\enginuity\\components\\pages.jsx");
